var Event = /** @class */ (function () {
    /**
     * 构造函数
     */
    function Event(type) {
        this.type = type;
    }
    return Event;
}());
export default Event;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-message/Event/index.js
// module id = 2397
// module chunks = 0